import { Navigate } from 'react-router-dom'

/**
 * Legacy route. The pool experience moved to /portal/nominee.
 * Redirect here to preserve existing bookmarks/email links.
 */
export default function Pool() {
  return <Navigate to="/portal/nominee" replace />
}
